import React from 'react';

import Select, {SelectProps} from '@material-ui/core/Select';

import styles from './BootstrapTextField.module.css';


const BootstrapSelect = (props: SelectProps) => {

  return (
    <Select
      className={styles.root}
      classes={{select: styles.input, disabled: styles.disabled}}
      {...props}
    >
      {props.children}
    </Select>
  )
};

export default React.memo(BootstrapSelect);